"use strict";
/*
 * Created on 2019-03-28
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var utils_1 = require("../../../core/utils");

var SelloutTarget_1 = require("../../model/sellout/SelloutTarget");

var SelloutTargetConverter_1 = require("./SelloutTargetConverter");
/**
 * @author Radek Beran
 */


var SelloutTargetConverterImpl =
/*#__PURE__*/
function (_SelloutTargetConvert) {
  _inherits(SelloutTargetConverterImpl, _SelloutTargetConvert);

  function SelloutTargetConverterImpl() {
    _classCallCheck(this, SelloutTargetConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTargetConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutTargetConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutTarget_1.SelloutTarget(SelloutTarget_1.SelloutTarget.schema.id.valueOf(conversions.documentToClassId(source)), SelloutTarget_1.SelloutTarget.schema.releaseId.valueOf(conversions.toClassReferenceId(source.releaseId)), SelloutTarget_1.SelloutTarget.schema.categoryId.valueOf(conversions.toClassReferenceId(source.categoryId)), !utils_1.Utils.isValueMissing(source.targetMargin) ? conversions.toBigNumber(source.targetMargin) : null, !utils_1.Utils.isValueMissing(source.targetProfit) ? conversions.toBigNumber(source.targetProfit) : null);
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var result = {};
      result = Object.assign(result, conversions.classToDocumentId(source));
      result = Object.assign(result, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        categoryId: conversions.toDocumentReferenceId(source.categoryId),
        targetMargin: conversions.asObjectOpt(source, 'targetMargin', function (v) {
          return conversions.fromBigNumber(v);
        }),
        targetProfit: conversions.asObjectOpt(source, 'targetProfit', function (v) {
          return conversions.fromBigNumber(v);
        })
      });
      return result;
    }
  }]);

  return SelloutTargetConverterImpl;
}(SelloutTargetConverter_1.SelloutTargetConverter);

exports.SelloutTargetConverterImpl = SelloutTargetConverterImpl;